"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionType = void 0;

/**
 * Master list of valid schemas for analytics actions
 *
 * Each event describes one ActionType
 */

/**
 * The top-level actions an Event describes.
 *
 * Each ActionType corresponds with a table in Redshift.
 */
let ActionType;
exports.ActionType = ActionType;

(function (ActionType) {
  ActionType["authImpression"] = "authImpression";
  ActionType["addToCalendar"] = "addToCalendar";
  ActionType["addCollectedArtwork"] = "addCollectedArtwork";
  ActionType["clickedAppDownload"] = "clickedAppDownload";
  ActionType["clickedArticleGroup"] = "clickedArticleGroup";
  ActionType["clickedArtistGroup"] = "clickedArtistGroup";
  ActionType["clickedArtistSeriesGroup"] = "clickedArtistSeriesGroup";
  ActionType["clickedArtworkGroup"] = "clickedArtworkGroup";
  ActionType["clickedAuctionGroup"] = "clickedAuctionGroup";
  ActionType["clickedCollectionGroup"] = "clickedCollectionGroup";
  ActionType["clickedFairCard"] = "clickedFairCard";
  ActionType["clickedFairGroup"] = "clickedFairGroup";
  ActionType["clickedMainArtworkGrid"] = "clickedMainArtworkGrid";
  ActionType["clickedNavigationTab"] = "clickedNavigationTab";
  ActionType["clickedPartnerCard"] = "clickedPartnerCard";
  ActionType["clickedShowMore"] = "clickedShowMore";
  ActionType["clickedViewingRoomCard"] = "clickedViewingRoomCard";
  ActionType["commercialFilterParamsChanged"] = "commercialFilterParamsChanged";
  ActionType["createdAccount"] = "createdAccount";
  ActionType["deleteCollectedArtwork"] = "deleteCollectedArtwork";
  ActionType["editCollectedArtwork"] = "editCollectedArtwork";
  ActionType["focusedOnConversationMessageInput"] = "focusedOnConversationMessageInput";
  ActionType["focusedOnSearchInput"] = "focusedOnSearchInput";
  ActionType["followedArtist"] = "followedArtist";
  ActionType["followedFair"] = "followedFair";
  ActionType["followedGene"] = "followedGene";
  ActionType["followedPartner"] = "followedPartner";
  ActionType["onboardingUserInputData"] = "onboardingUserInputData";
  ActionType["resetYourPassword"] = "resetYourPassword";
  ActionType["saleScreenLoadComplete"] = "saleScreenLoadComplete";
  ActionType["screen"] = "screen";
  ActionType["searchedWithNoResults"] = "searchedWithNoResults";
  ActionType["selectedItemFromSearch"] = "selectedItemFromSearch";
  ActionType["sentConversationMessage"] = "sentConversationMessage";
  ActionType["successfullyLoggedIn"] = "successfullyLoggedIn";
  ActionType["tappedArticleGroup"] = "tappedArticleGroup";
  ActionType["tappedArtistGroup"] = "tappedArtistGroup";
  ActionType["tappedArtistSeriesGroup"] = "tappedArtistSeriesGroup";
  ActionType["tappedArtworkGroup"] = "tappedArtworkGroup";
  ActionType["tappedAuctionGroup"] = "tappedAuctionGroup";
  ActionType["tappedAuctionResultGroup"] = "tappedAuctionResultGroup";
  ActionType["tappedCollectedArtwork"] = "tappedCollectedArtwork";
  ActionType["tappedCollectedArtworkImages"] = "tappedCollectedArtworkImages";
  ActionType["tappedCollectionGroup"] = "tappedCollectionGroup";
  ActionType["tappedConsign"] = "tappedConsign";
  ActionType["tappedExploreGroup"] = "tappedExploreGroup";
  ActionType["tappedFairGroup"] = "tappedFairGroup";
  ActionType["tappedFairCard"] = "tappedFairCard";
  ActionType["tappedInboxConversation"] = "tappedInboxConversation";
  ActionType["tappedInfoBubble"] = "tappedInfoBubble";
  ActionType["tappedMainArtworkGrid"] = "tappedMainArtworkGrid";
  ActionType["tappedNavigationTab"] = "tappedNavigationTab";
  ActionType["tappedPartnerCard"] = "tappedPartnerCard";
  ActionType["tappedPromoSpace"] = "tappedPromoSpace";
  ActionType["tappedRegisterToBid"] = "tappedRegisterToBid";
  ActionType["tappedSell"] = "tappedSell";
  ActionType["tappedShowMore"] = "tappedShowMore";
  ActionType["tappedTabBar"] = "tappedTabBar";
  ActionType["tappedVerifyIdentity"] = "tappedVerifyIdentity";
  ActionType["tappedViewingRoomCard"] = "tappedViewingRoomCard";
  ActionType["tappedViewingRoomGroup"] = "tappedViewingRoomGroup";
  ActionType["timeOnPage"] = "timeOnPage";
  ActionType["toggledNotification"] = "toggledNotification";
  ActionType["unfollowedArtist"] = "unfollowedArtist";
  ActionType["unfollowedFair"] = "unfollowedFair";
  ActionType["unfollowedGene"] = "unfollowedGene";
  ActionType["unfollowedPartner"] = "unfollowedPartner";
})(ActionType || (exports.ActionType = ActionType = {}));